/**
 * @fileoverview Layout for the company Location section address fields.
 */

import React from "react";
import styles from "./Location.module.css";
import LocationBranchesField from "./LocationBranchesField";
import SecondAddressBetweenStreet2Field from "./SecondAddressBetweenStreet2Field";
import SecondAddressCountrySelect from "./SecondAddressCountrySelect";
import SecondAddressDetailFields from "./SecondAddressDetailFields";
import SecondAddressNeighborhoodSelect from "./SecondAddressNeighborhoodSelect";
import SecondAddressPostalSelect from "./SecondAddressPostalSelect";
import SecondAddressStateSelect from "./SecondAddressStateSelect";
import SecondAddressStreetFields from "./SecondAddressStreetFields";
import SecondAddressTownSelect from "./SecondAddressTownSelect";

const LocationSectionView = ({ model, t }) => {
  return (
    <div className={styles.sectionContent}>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>
          {t("components.location.address2Title")}
        </span>
        <div className={styles.sectionDivider}></div>
      </div>
      <div className={styles.inputRow}>
        <SecondAddressStreetFields model={model} t={t} />
        <SecondAddressDetailFields model={model} t={t} />
      </div>
      <div className={`${styles.inputRow} ${styles.twoInputsRow}`}>
        <SecondAddressBetweenStreet2Field model={model} t={t} />
        <SecondAddressCountrySelect model={model} t={t} />
        <SecondAddressStateSelect model={model} t={t} />
        <SecondAddressTownSelect model={model} t={t} />
      </div>
      <div className={`${styles.inputRow} ${styles.twoInputsRow}`}>
        <SecondAddressNeighborhoodSelect model={model} t={t} />
        <SecondAddressPostalSelect model={model} t={t} />
      </div>
      <div className={`${styles.inputRow} ${styles.twoInputsRow}`}>
        <LocationBranchesField model={model} t={t} />
      </div>
    </div>
  );
};

export default LocationSectionView;
